import { render, staticRenderFns } from "./userType-select.vue?vue&type=template&id=661c5e94&scoped=true&"
import script from "./userType-select.vue?vue&type=script&lang=js&"
export * from "./userType-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661c5e94",
  null
  
)

export default component.exports